import React from 'react';

import MaskedInput, { MaskedInputProps } from './MaskedInput';

export interface MaskedInputPhoneProps extends MaskedInputProps {}

const MaskedInputPhone: React.FC<MaskedInputPhoneProps> = (props) => (
  <MaskedInput
    {...props}
    mask={['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    placeholder="(000) 000-0000"
    inputMode="numeric"
  />
);

export default MaskedInputPhone;
